import React, { useState, useEffect } from "react";
import { Layout, Button, Modal, Input, Upload } from "antd";
import {
  ScanOutlined,
  PrinterOutlined,
  ExclamationOutlined,
} from "@ant-design/icons";
import QrcodeComponent from "../../components/Qrcode";
import Init from "../../components/InitPatrol";
import { Report } from "../../services/report";
import { getCheckpointByUUIDService } from "../../services/checkpoint";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import th from "date-fns/locale/th";

const { RangePicker } = DatePicker;

const { Content } = Layout;
const { TextArea } = Input;

// Register the Thai locale
registerLocale("th", th);

const PatrolIndex = () => {
  const [size, setSize] = useState("large");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState({
    start_date: (() => {
      const now = new Date();
      now.setHours(now.getHours() - 1);
      return `${String(now.getDate()).padStart(2, '0')}/${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    })(),
    end_date: (() => {
      const now = new Date();
      return `${String(now.getDate()).padStart(2, '0')}/${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    })()
  });
  const [checkpoint, setCheckpoint] = useState([]);
  const [showCheckpoint, setShowCheckpoint] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsOpen(false);
  };

  const dummyRequest = ({ file, onSuccess }) => {
    // convert file to base64 string

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setValue({ ...value, image: reader.result.replace("data:image/jpeg;base64,", "").replace("data:image/png;base64,", "") });
    };

    onSuccess("ok");
  };

  const haversine = (lat1, lon1, lat2, lon2) => {
    // Radius of the Earth in kilometers
    const R = 6371.0;

    // Convert latitude and longitude from degrees to radians
    const toRadians = (degrees) => degrees * (Math.PI / 180);
    lat1 = toRadians(lat1);
    lon1 = toRadians(lon1);
    lat2 = toRadians(lat2);
    lon2 = toRadians(lon2);

    // Difference in coordinates
    const dlat = lat2 - lat1;
    const dlon = lon2 - lon1;

    // Haversine formula
    const a =
      Math.sin(dlat / 2) ** 2 +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dlon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // Distance in kilometers, converted to meters
    const distance = R * c;

    return distance * 1000; // return distance in meters
  };

  const handleOk = () => {
    if (!value.image) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "กรุณาแนบภาพก่อนส่งรายงาน",
      });
      return;
    }
    if (!value.start_date || !value.end_date) {
      const now = new Date();
      const oneHourAgo = new Date(now);
      oneHourAgo.setHours(now.getHours() - 1);
      
      const formattedStartDate = `${String(oneHourAgo.getDate()).padStart(2, '0')}/${String(oneHourAgo.getMonth() + 1).padStart(2, '0')}/${oneHourAgo.getFullYear()} ${String(oneHourAgo.getHours()).padStart(2, '0')}:${String(oneHourAgo.getMinutes()).padStart(2, '0')}`;
      const formattedEndDate = `${String(now.getDate()).padStart(2, '0')}/${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

      setValue({
        ...value,
        start_date: formattedStartDate,
        end_date: formattedEndDate
      });
    }

    setIsSubmitting(true);
    Report({
      account_uuid: "",
      site_uuid: JSON.parse(localStorage.getItem("device"))[1],
      start_date: value.start_date,
      end_date: value.end_date,
      mode: "",
      name: value.name,
      message: value.message,
      image: value.image,
    })
      .then((res) => {
        notification.success({
          message: "ส่งรายงานสำเร็จ",
          description: "รายงานของคุณถูกส่งเรียบร้อยแล้ว",
        });
        setValue({});
        setTimeout(() => {
          window.location.reload(); // ✅ รีโหลดหน้าเว็บหลังจากแจ้งเตือน
        }, 1000);
        setIsOpen(false);
      })
      .catch((err) => {
        console.error(err);
        notification.error({
          message: "เกิดข้อผิดพลาด",
          description: "ไม่สามารถส่งรายงานได้ กรุณาลองอีกครั้ง",
        });
      })
      .finally(() => {
        setIsSubmitting(false); // เปิดปุ่มอีกครั้งหลังส่งเสร็จ
      });
  };

  const data = [
    {
      key: "1",
      label: "เริ่มการเดินตรวจ",
      icon: <ScanOutlined className="text-[64px]" />,
      bg: "green",
      color: "#ffff",
      action: () => {
        setIsModalOpen(true);
      },
    },
    {
      key: "1",
      label: "เหตุผิดปกติ",
      icon: <ExclamationOutlined className="text-[64px]" />,
      bg: "#BB1616",
      color: "#ffff",
      action: () => {
        navigate(
          "/patrol/v1?device=" +
          JSON.parse(localStorage.getItem("device"))[2] +
          "&checkpoint=abnormal"
        );
      },
    },
    {
      key: "2",
      label: "ส่งรายงาน",
      icon: <PrinterOutlined className="text-[64px]" />,
      bg: "#FFC13F",
      color: "#111",
      action: () => {
        setIsOpen(true);
      },
    },
  ];

  useEffect(() => {
    if (localStorage.getItem("device")) {
      getCheckpointByUUIDService(JSON.parse(localStorage.getItem("device"))[2])
        .then((res) => {
          setCheckpoint(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  useEffect(() => {
    const calculateDistance = async () => {
      setShowCheckpoint([]);
      if (checkpoint.length > 0) {
        const lat = JSON.parse(localStorage.getItem("location"))?.lat;
        const lon = JSON.parse(localStorage.getItem("location"))?.lon;

        checkpoint.map((item) => {
          if (item.checkpoint_lat === null || item.checkpoint_long === null) {
            return;
          }
          const distance = haversine(
            lat,
            lon,
            item.checkpoint_lat,
            item.checkpoint_long
          );
          setShowCheckpoint((prev) => [
            ...prev,
            {
              checkpoint_name: item.checkpoint_name,
              checkpoint_lat: item.checkpoint_lat,
              checkpoint_long: item.checkpoint_long,
              distance: distance,
            },
          ]);
        });
      }
    };
    calculateDistance();
    setInterval(() => {
      calculateDistance();
    }, 5000);
  }, [checkpoint]);

  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
      className="w-[50%] h-12 px-4 py-2 text-lg border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      onClick={onClick}
      value={value}
      readOnly // ปิดคีย์บอร์ด
      ref={ref}
    />
  ));

  return (
    <Content
      className="flex items-center justify-center"
      style={{ margin: "0 16px" }}
    >
      <div className="grid grid-cols-1">
        <Init />
        <Modal
          title="ส่งรายงาน"
          open={isOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okButtonProps={{
            disabled: isSubmitting || !value.image || !value.start_date || !value.end_date,
            loading: isSubmitting,
          }}
        >
          <div className="grid grid-cols-1 gap-2 items-center">
            <div className="space-y-6">
              <div className="space-y-2">
                <label className="block text-lg font-medium text-gray-700">เวลาเริ่มตรวจ</label>
                <div className="flex space-x-4">
                  <div className="flex-1">
                    <label className="block text-sm text-gray-600 mb-1">วันที่</label>
                    <DatePicker
                      className="w-full h-12 px-4 py-2 text-lg border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      selected={value.start_date ? new Date(value.start_date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')) : (() => {
                        const now = new Date();
                        now.setHours(now.getHours() - 1);
                        return now;
                      })()}
                      onChange={(date) => {
                        if (!date) return;
                        const currentTime = value.start_date ? new Date(value.start_date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')) : (() => {
                          const now = new Date();
                          now.setHours(now.getHours() - 1);
                          return now;
                        })();
                        const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()} ${String(currentTime.getHours()).padStart(2, '0')}:${String(currentTime.getMinutes()).padStart(2, '0')}`;
                        setValue({
                          ...value,
                          start_date: formattedDate
                        });
                      }}
                      dateFormat="dd/MM/yyyy"
                      locale="th"
                      customInput={<CustomInput />}
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm text-gray-600 mb-1">เวลา</label>
                    <DatePicker
                      className="w-full h-12 px-4 py-2 text-lg border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      selected={value.start_date ? new Date(value.start_date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')) : new Date()}
                      onChange={(time) => {
                        if (!time) return;
                        const currentDate = value.start_date ? new Date(value.start_date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')) : new Date();
                        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}/${String(currentDate.getMonth() + 1).padStart(2, '0')}/${currentDate.getFullYear()} ${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}`;
                        setValue({
                          ...value,
                          start_date: formattedDate
                        });
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="HH:mm"
                      locale="th"
                      customInput={<CustomInput />}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <label className="block text-lg font-medium text-gray-700">เวลาหยุดตรวจ</label>
                <div className="flex space-x-4">
                  <div className="flex-1">
                    <label className="block text-sm text-gray-600 mb-1">วันที่</label>
                    <DatePicker
                      className="w-full h-12 px-4 py-2 text-lg border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      selected={value.end_date ? new Date(value.end_date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')) : new Date()}
                      onChange={(date) => {
                        if (!date) return;
                        const currentTime = value.end_date ? new Date(value.end_date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')) : new Date();
                        const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()} ${String(currentTime.getHours()).padStart(2, '0')}:${String(currentTime.getMinutes()).padStart(2, '0')}`;
                        setValue({
                          ...value,
                          end_date: formattedDate
                        });
                      }}
                      dateFormat="dd/MM/yyyy"
                      locale="th"
                      customInput={<CustomInput />}
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm text-gray-600 mb-1">เวลา</label>
                    <DatePicker
                      className="w-full h-12 px-4 py-2 text-lg border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      selected={value.end_date ? new Date(value.end_date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')) : new Date()}
                      onChange={(time) => {
                        if (!time) return;
                        const currentDate = value.end_date ? new Date(value.end_date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')) : new Date();
                        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}/${String(currentDate.getMonth() + 1).padStart(2, '0')}/${currentDate.getFullYear()} ${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}`;
                        setValue({
                          ...value,
                          end_date: formattedDate
                        });
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="HH:mm"
                      locale="th"
                      customInput={<CustomInput />}
                    />
                  </div>
                </div>
              </div>
            </div>
            <Upload
              customRequest={dummyRequest}
              listType="picture-card"
              maxCount={1}
              multiple
              accept="image/x-png,image/jpeg"
              capture="environment"
            >
              {value.image !== "" && "+ ยืนยันตัวตน"}
            </Upload>
            <div>ชื่อผู้รายงาน</div>
            <TextArea
              className="h-[55px]"
              placeholder="ชื่อผู้รายงาน"
              value={value.name}
              onChange={(e) => setValue({ ...value, name: e.target.value })}
            />
            <div>บันทึกข้อความ</div>
            <TextArea
              className="h-[55px]"
              placeholder="บันทึกข้อความ"
              value={value.message}
              onChange={(e) => setValue({ ...value, message: e.target.value })}
            />
          </div>
        </Modal>
        <QrcodeComponent
          open={isModalOpen}
          cancel={handleCancel}
          haversine={haversine}
        />
        {data.map((item) => (
          <Button
            key={item.key}
            onClick={item.action}
            style={{ backgroundColor: item.bg, color: item.color }}
            className="flex items-center justify-between mt-[24px] w-[280px] h-[120px] text-[24px] font-bold rounded-lg"
            icon={item.icon}
            size={size}
          >
            {item.label}
          </Button>
        ))}
        {showCheckpoint.length > 0 && (
          <div className="grid grid-cols-1 gap-2 mt-[24px]">
            <div className="text-[24px] font-bold">จุดตรวจ</div>
            {showCheckpoint
              .sort((a, b) => a.distance - b.distance)
              .map((item) => (
                <div
                  key={item.checkpoint_name}
                  className="flex items-center justify-between w-[280px] text-[18px] font-bold rounded-lg"
                >
                  <div>{item.checkpoint_name}</div>
                  <div>{item.distance.toFixed(2)} m</div>
                </div>
              ))}
          </div>
        )}
      </div>
    </Content>
  );
};

export default PatrolIndex;